(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-qgc-finder-results-copy]').forEach(note => {
      const params = new URLSearchParams(window.location.search);
      if (params.get('qgc_gift_finder') !== '1') return;
      const value = name => (params.get(`filter.p.m.qgc_gift_finder.${name}`) || '').trim().toLowerCase().slice(0, 64);
      const recipient = value('recipient');
      const interest = value('interest');
      const occasion = value('occasion');
      if (!recipient && !interest && !occasion) return;
      let copy = "We're looking for gifts";
      if (recipient) copy += ` for ${recipient}`;
      if (interest) copy += recipient ? `, interested in ${interest}` : ` for someone interested in ${interest}`;
      if (occasion) copy += recipient || interest ? ` and for their ${occasion}` : ` for their ${occasion}`;
      note.textContent = `${copy}.`;
    });
    scope.querySelectorAll('a[href="#qgc-all-reviews"]').forEach(link => {
      if (link.dataset.initialized) return;
      link.dataset.initialized = 'true';
      link.addEventListener('click', event => { event.preventDefault(); document.getElementById('qgc-all-reviews')?.showModal(); });
    });
    scope.querySelectorAll('[data-qgc-close-reviews]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });
    scope.querySelectorAll('[data-qgc-legacy-finder]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const answers = new FormData(form);
        const params = new URLSearchParams();
        const recipient = answers.get('recipient');
        let interest = answers.get('interest');
        const chosenRecipient = form.querySelector('input[name="recipient"]:checked');
        if (chosenRecipient?.nextElementSibling?.textContent.trim() === 'Football fan' && !interest) interest = 'Football';
        if (recipient) params.set('filter.p.m.qgc_gift_finder.recipient', recipient);
        if (interest) params.set('filter.p.m.qgc_gift_finder.interest', interest);
        params.set('filter.p.m.qgc_gift_finder.enabled', 'true');
        params.set('filter.p.m.qgc_gift_finder.review_status', 'Approved');
        params.set('qgc_gift_finder', '1');
        params.set('sort_by', 'best-selling');
        const budget = answers.get('budget');
        if (budget) {
          const [minimum, maximum] = budget.split(':');
          if (minimum) params.set('filter.v.price.gte', minimum);
          if (maximum) params.set('filter.v.price.lte', maximum);
        }
        const current = new URL(window.location.href);
        if (current.searchParams.has('preview_theme_id')) params.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
        const chosenInterest = form.querySelector('input[name="interest"]:checked');
        const destination = chosenInterest?.dataset.collectionUrl || chosenRecipient?.dataset.collectionUrl || form.action.split('?')[0];
        window.location.assign(destination + '?' + params.toString());
      });
    });
    scope.querySelectorAll('[data-qgc-scroll]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const section = button.closest('.qgc-page');
      const track = section?.querySelector('[data-qgc-scroll-track]');
      if (!track) return;
      button.addEventListener('click', () => {
        const carousel = section.querySelector('[data-jdgm-block-id]');
        const direction = Number(button.dataset.qgcScroll);
        if (carousel) {
          const nativeButton = carousel.querySelector(direction < 0 ? '[aria-label="Previous slide"]' : '[aria-label="Next slide"]');
          nativeButton?.click();
        }
        track.scrollBy({left: track.clientWidth * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      if (!track.dataset.qgcControlsReady) {
        track.dataset.qgcControlsReady = 'true';
        let scheduled = false;
        const update = () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => {
            scheduled = false;
            const width = track.clientWidth, total = track.scrollWidth, left = track.scrollLeft;
            const carousel = section.querySelector('[data-jdgm-block-id]');
            section.querySelectorAll('[data-qgc-scroll]').forEach(control => {
              control.disabled = !carousel && (total <= width + 2 || (Number(control.dataset.qgcScroll) < 0 ? left <= 2 : left + width >= total - 2));
            });
          });
        };
        track.addEventListener('scroll', update, {passive:true});
        new ResizeObserver(update).observe(track);
      }
    });
    scope.querySelectorAll('.qgc-menu-toggle').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const menu = document.getElementById(button.getAttribute('aria-controls'));
        if (!menu) return;
        menu.hidden = !menu.hidden;
        button.setAttribute('aria-expanded', String(!menu.hidden));
        button.setAttribute('aria-label', menu.hidden ? 'Open menu' : 'Close menu');
      });
    });
    scope.querySelectorAll('.qgc-dropdown').forEach(details => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) document.querySelectorAll('.qgc-dropdown').forEach(other => { if (other !== details) other.open = false; });
      });
    });
    scope.querySelectorAll('.qgc-mobile-group').forEach(details => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) details.closest('nav').querySelectorAll('.qgc-mobile-group').forEach(other => { if (other !== details) other.open = false; });
      });
    });
    const review = document.querySelector('.qgc-real-review');
    if (review) {
      const synchronize = () => {
        const cards = review.querySelectorAll('.jdgm-testimonial,.jdgm-rev-snippet-card');
        const fallback = review.querySelector('.qgc-review-fallback');
        if (fallback) fallback.hidden = cards.length > 0;
      };
      new MutationObserver(synchronize).observe(review, {childList:true,subtree:true});
      synchronize();
    }
  }
  document.querySelectorAll('[data-qgc-count]').forEach(node => { const count = Number(node.textContent.trim()); if (Number.isFinite(count)) node.textContent = count.toLocaleString('en-GB'); });
  document.addEventListener('click', event => document.querySelectorAll('.qgc-dropdown[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.qgc-dropdown[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); }); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
